import React, { createContext, ReactNode, useState } from "react";

interface City {
    city_id: number;
    city_name: string;
    flag_active: boolean;
    created_at_timestamp: string;
    updated_at_timestamp: string;
}

interface ContractStatus {
    contract_status_id: number;
    contract_status_name: string;
}

interface HotelType {
    hotel_type_id: number;
    hotel_type_name: string;
}

interface ExcursionType {
    excursion_type_id: number;
    excursion_type_name: string;
}

interface Category {
    category_id: number;
    category_name: string;
}

interface PlaceType {
    place_type_id: number;
    place_type_name: string;
}

interface SeatingType {
    seating_type_id: number;
    seating_type_name: string;
}

interface RateStructureType {
    rate_structure_type_id: number;
    rate_structure_type_name: string;
}

interface MealPlanType {
    meal_plan_type_id: number;
    meal_plan_type_name: string;
}

interface GitFitType {
    git_fit_type_id: number;
    git_fit_type_name: string;
}

interface TippingType {
    tipping_type_id: number;
    tipping_type_name: string;
}

interface DayTripType {
    day_trip_type_id: number;
    day_trip_type_name: string;
}

interface HotelGenericData {
    city: City[];
    contract_status: ContractStatus[];
    hotel_type: HotelType[];
    excursion_type: ExcursionType[];
    category: Category[];
    place_type: PlaceType[];
    seating_type: SeatingType[];
    rate_structure_type: RateStructureType[];
    meal_plan_type: MealPlanType[];
    git_fit_type: GitFitType[];
    tipping_type: TippingType[];
    day_trip_type: DayTripType[];
}

interface HotelGenericContextType {
    hotelGenericData: HotelGenericData;
    setHotelGenericData: (hotelGenericData: HotelGenericData) => void;
}

const HotelGenericContext = createContext<HotelGenericContextType | undefined>(undefined);

interface HotelGenericProviderProps {
    children: ReactNode;
}

const HotelGenericProvider = ({ children }: HotelGenericProviderProps) => {
    const [hotelGenericData, setHotelGenericData] = useState<HotelGenericData>({
        city: [],
        contract_status: [],
        hotel_type: [],
        excursion_type: [],
        category: [],
        place_type: [],
        seating_type: [],
        rate_structure_type: [],
        meal_plan_type: [],
        git_fit_type: [],
        tipping_type: [],
        day_trip_type: [],
    });

    const payload = {
        hotelGenericData,
        setHotelGenericData,
    };

    return (
        <HotelGenericContext.Provider value={payload}>
            {children}
        </HotelGenericContext.Provider>
    );
};

const useHotelGeneric = () => {
    const context = React.useContext(HotelGenericContext);
    if (!context) {
        throw new Error('useHotelGeneric must be used within a HotelGenericProvider');
    }
    return context;
};

export { HotelGenericProvider, HotelGenericContext, useHotelGeneric };

